import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Button, Grid, Header, Segment } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const formValues =
    state.form && state.form[ownProps.form] && state.form[ownProps.form].values
  return { formValues }
}

class InlineForm extends React.Component {
  render() {
    const { initialized, getTitle, children, onSubmit, formValues } = this.props
    const { destroy } = this.props

    return (
      initialized && (
        <Segment attached basic className="InlineForm">
          <Grid stackable className="form ui">
            <Grid.Row>
              <Grid.Column width={12}>
                <Header
                  as="h3"
                  content={getTitle(formValues)}
                  icon="cancel"
                  className="icon-right"
                  onClick={(event) => {
                    event.preventDefault()
                    destroy()
                  }}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12} children={children} />
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12} textAlign="right">
                <Button
                  onClick={(event) => {
                    event.preventDefault()
                    destroy()
                    onSubmit(formValues)
                  }}
                  positive
                  icon="checkmark"
                  labelPosition="right"
                  content={I18n.t('global.save')}
                  primary
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      )
    )
  }
}

InlineForm = connect(mapStateToProps)(InlineForm)
InlineForm = reduxForm()(InlineForm)
export default InlineForm



// WEBPACK FOOTER //
// ./src/components/admin/Helper/InlineForm.jsx